import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import configureStore from './store/configure-store'

export const store = configureStore()

const setupApp = () =>
  new Promise((resolve, reject) => {
    const history = syncHistoryWithStore(browserHistory, store)
    resolve({ store, history })
  })

export default setupApp



// WEBPACK FOOTER //
// ./src/setupApp.js